import React from 'react';

import {Table as BootstrapTable, Button} from 'react-bootstrap'

const moment = require('moment')

const ViewForm = props => {
	let {selectedData, schema} = props;
	console.log('view', schema)
	console.log('data', selectedData)

	const isUndefined = (obj) => typeof obj === 'undefined'
		? true
		: false;

	var exclude = ['OBJECTID']

	const format = (obj, column) => {
		// console.log(dataType, obj)
		switch (column.type.toUpperCase()) {
			case 'STRING':
				return obj
					? obj.toUpperCase()
					: '';
			case 'DATE':
				var format = isUndefined(column.format)
					? 'MMM-DD-YYYY'
					: column.format
				return obj
					? moment(obj).format(format).toUpperCase()
					: '';
			case 'POINTER':
				return obj
					? obj.get(column.displayColumn)
					: '';
			case 'NUMBER':
				return obj
					? obj
					: '';
			case 'BOOLEAN':
				return isUndefined(obj)
					? ''
					: obj.toString();
			case 'PARSEFILE':
				return isUndefined(obj)
					? ''
					: <div style={{
						maxWidth: '200px',
						maxHeight: '200px',
						height: '200px',
						width: '200px',
						display: 'table-cell',
						verticalAlign: 'middle'
					}}><img src={obj.url()} width="100%"/></div>;
			default:
				return obj
		}
	}

	const renderTrueValue = (value, column, obj) => {
		if (!isUndefined(column.render) && typeof column.render === "function") {
			return column.render({
				value: format(value, column),
				column,
				getTableData: undefined,
				object: obj
			});
		} else {
			return format(value, column);
		}
	};

	const renderTr = (obj) => {
		console.log(obj)
		return exclude.indexOf(obj.columnName.toUpperCase()) === -1 || obj.show
			? (
				<tr key={obj.columnName}>
					<td>
						<b>{isUndefined(obj.columnLabel)
								? obj.columnName.toUpperCase()
								: obj.columnLabel.toUpperCase()}</b>
					</td>
					<td>{renderTrueValue(selectedData.get(obj.columnName), obj, selectedData)}</td>
					{/*<td>{format(selectedData.get(obj.columnName), obj)}</td>*/}
				</tr>
			)
			: <tr></tr>
	}
	return (
		<BootstrapTable bordered responsive>
			<tbody>
				{isUndefined(schema)
					? <tr></tr>
					: schema.columns.map(renderTr)}
			</tbody>
		</BootstrapTable>
	)
}

export default ViewForm;



// WEBPACK FOOTER //
// ./components/zynappse-crud/Form/_view.js